import { updateItemInCollection } from "directus/src/operations";

export async function createFixedConfig({ jobId, values }) {
  try {
    const query = {
      fields: ["id", "amount", "fixed_job_config.id", "fixed_job_config.amount", "fixed_job_config.currency"],
    };
    const response = await updateItemInCollection(
      "jobs",
      jobId,
      {
        fixed_job_config: values,
      },
      query
    );
    return response;
  } catch (error) {
    console.error("Error creating fixed config:", error);
    throw error;
  }
}

export async function updateFixedConfig({ id, values }) {
  try {
    const query = {
      fields: ["id", "amount", "currency"],
    };
    const response = await updateItemInCollection(
      "fixed_job_config",
      id,
      values,
      query
    );
    return response;
  } catch (error) {
    console.error("Error updating fixed config:", error);
    throw error;
  }
}
